import type { AppRoute } from "@/types/routes";

export function prefixRoutes(
    routes: readonly AppRoute[],
    prefix: string
): readonly AppRoute[] {
    return routes.map((r) => {
        // Copy
        const copy: any = { ...r };

        // Index route blijft index route (die vangen we in /en apart af met een redirect)
        if (copy.index) return copy;

        // Alleen string paden prefixen
        if (typeof copy.path === "string") {
            // "*" laten we "*"
            if (copy.path === "*") return copy;

            // Absolute paths prefixen
            if (copy.path.startsWith("/")) {
                copy.path = `${prefix}${copy.path}`;
            }
        }

        // (Als je ooit nested children toevoegt)
        if (Array.isArray(copy.children)) {
            copy.children = prefixRoutes(copy.children, prefix);
        }

        return copy as AppRoute;
    });
}
